<script>

    import 'flatpickr/dist/flatpickr.css'
    import { Spanish } from 'flatpickr/dist/l10n/es.js'
    import Moment from 'moment'
    import Flatpickr from 'svelte-flatpickr'
    import { createEventDispatcher } from 'svelte'

    export let dateStart = Moment().subtract(1, 'year').startOf('day').toDate()
    export let dateEnd = Moment().endOf('day').toDate()

    const dispatch = createEventDispatcher()

    let openPicker = false

    $: year = Moment(dateEnd).year()
    $: pickerOptions = {
        inline: true,
        enableTime: false,
        locale: Spanish,
        defaultDate: dateEnd,
    }

    function formatDate(date) {
        return Moment(date).locale('es').format('DD MMM YYYY')
    }

    function emitChange() {
        dispatch('change', { dateStart, dateEnd })
    }

    function setYear(value) {
        const now = Moment()
        let end = now.clone().year(value)

        if (end.isAfter(now, 'day'))
            end = now.clone()

        dateEnd = end.endOf('day').toDate()
        dateStart = Moment(dateEnd).subtract(1, 'year').startOf('day').toDate()
        emitChange()
    }

    function shiftYear(delta) {
        setYear(year + delta)
        openPicker = false
    }

    function onPickerChange(ev) {
        const picked = ev.detail?.[0]
        if (!picked) return

        setYear(Moment(picked).year())
        openPicker = false
    }

    function clickOutside(node, onClose) {
        const onClick = (event) => {
            if (!node.contains(event.target) && !event.target.closest('.date-year-nav__dates'))
                onClose()
        }

        setTimeout(() => document.addEventListener('click', onClick), 0)

        return {
            destroy() {
                document.removeEventListener('click', onClick)
            },
        }
    }

</script>

<style>
    .date-year-nav {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        user-select: none;
    }

    .date-year-nav__arrow,
    .date-year-nav__dates {
        background: none;
        border: none;
        cursor: pointer;
        color: #3a3a3a;
        line-height: 1;
        padding: 0.35rem 0.5rem;
        border-radius: 6px;
        transition: background 0.15s ease, color 0.15s ease;
    }

    .date-year-nav__arrow {
        font-size: 13px;
        padding: 0.35rem 0.4rem;
        color: #888;
    }

    .date-year-nav__arrow:hover,
    .date-year-nav__dates:hover,
    .date-year-nav__dates.is-active {
        background: #f4f4f4;
        color: #1a1a1a;
    }

    .date-year-nav__dates-wrap {
        position: relative;
    }

    .date-year-nav__dates {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 14px;
        font-weight: 600;
        text-transform: capitalize;
    }

    .date-year-nav__sep {
        font-size: 13px;
        font-weight: 400;
        color: #a0a0a0;
        text-transform: none;
    }

    .date-year-nav__popover {
        position: absolute;
        top: calc(100% + 6px);
        left: 50%;
        transform: translateX(-50%);
        z-index: 20;
        background: #fff;
        border: 1px solid #e8e8e8;
        border-radius: 8px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
        overflow: hidden;
    }

    .date-year-nav__popover :global(.flatpickr-calendar) {
        box-shadow: none;
    }
</style>

<div class="date-year-nav">
    <button type="button" class="date-year-nav__arrow" aria-label="Año anterior" on:click={() => shiftYear(-1)}>
        <i class="fas fa-chevron-left"></i>
    </button>

    <div class="date-year-nav__dates-wrap">
        <button
            type="button"
            class="date-year-nav__dates"
            class:is-active={openPicker}
            on:click|stopPropagation={() => openPicker = !openPicker}
        >
            <span>{formatDate(dateStart)}</span>
            <span class="date-year-nav__sep">a</span>
            <span>{formatDate(dateEnd)}</span>
        </button>

        {#if openPicker}
            <div class="date-year-nav__popover" use:clickOutside={() => openPicker = false}>
                <Flatpickr value={dateStart} options={pickerOptions} on:change={onPickerChange} />
            </div>
        {/if}
    </div>

    <button type="button" class="date-year-nav__arrow" aria-label="Año siguiente" on:click={() => shiftYear(1)}>
        <i class="fas fa-chevron-right"></i>
    </button>
</div>
